export default function ItemCardSkeleton() {
  return (
    <div className="bg-white rounded-xl overflow-hidden shadow-sm border border-[var(--border)]">
      {/* Image placeholder */}
      <div className="relative h-48 bg-[var(--bg-tint)] animate-pulse">
        <div className="absolute top-3 left-3 flex gap-2">
          <div className="w-12 h-5 bg-white/60 rounded-full"></div>
          <div className="w-12 h-5 bg-white/60 rounded-full"></div>
        </div>
      </div>

      {/* Content placeholder */}
      <div className="p-4 space-y-3">
        <div className="h-5 bg-[var(--border)] rounded animate-pulse w-3/4"></div>

        <div className="flex items-center gap-1">
          <div className="w-4 h-4 bg-[var(--border)] rounded animate-pulse"></div>
          <div className="h-4 bg-[var(--border)] rounded animate-pulse w-1/2"></div>
        </div>

        <div className="flex items-center gap-1">
          <div className="w-4 h-4 bg-[var(--border)] rounded animate-pulse"></div>
          <div className="h-4 bg-[var(--border)] rounded animate-pulse w-16"></div>
        </div>

        <div className="h-px bg-[var(--border)]"></div>

        <div className="flex items-end justify-between">
          <div className="flex flex-col gap-1">
            <div className="h-6 bg-[var(--border)] rounded animate-pulse w-20"></div>
          </div>
          <div className="h-4 bg-[var(--border)] rounded animate-pulse w-24"></div>
        </div>
      </div>
    </div>
  )
}
